<template>
  <wg-modal :simple="true" v-if="showPinModal" @closeModal="endAuthRequest">
    <div class="wg-row" slot="body" style="justify-content:center;">
      <template v-if="!checking">
        <div class="com-anm22-app-text-l" style="justify-content:center;">
          {{ $anm22.strLang(lang, 'Insert PIN', 'Inserire PIN') }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <input type="password" class="pin-request-input" readonly :value="pin">
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="pin-request-container">
          <div
              class="wg-row pin-request-cell"
              v-for="(key,index) in keys"
              :key="'keypad-'+index"
              @click="keyPressed(key)"
          >
            <div class="com-anm22-app-text-xl">
              {{ key }}
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="wg-row com-anm22-app-text-l" style="justify-content:center;">
          {{ $anm22.strLang(lang, 'Checking...', 'Autorizzazione in corso...') }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <vue-simple-spinner size="medium" :line-fg-color="appColor"></vue-simple-spinner>
        </div>
      </template>
    </div>
  </wg-modal>
</template>

<script>
import { mapState } from 'vuex';
import Spinner from 'vue-simple-spinner';

export default {
  components: {
    'vue-simple-spinner': Spinner
  },
  data() {
    return {
      showPinModal: false,
      checking: false,
      keys: [
        '7', '8', '9', '4', '5', '6', '3', '2', '1', 'x', '0', '<'
      ],
      pin: '',
      requestData: {}
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      appColor: state => state.config.appColor,
      licenseSelected: state => state.licenseSelected
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    }
  },
  methods: {
    initAuthRequest(data) {
      this.requestData = data;
      this.showPinModal = true;
    },
    endAuthRequest() {
      this.showPinModal = false;
      this.checking = false;
      this.pin = '';
      this.requestData = {};
    },
    keyPressed(key) {
      if(key === 'x') {
        this.pin = '';
      } else if(key === '<') {
        this.pin = this.pin.slice(0, -1);
      } else {
        this.pin += key;
      }
      if(this.pin.length === 4) {
        this.checkAuth();
      }
    },
    async checkAuth() {
      this.checking = true;
      const pin = this.$anm22.MD5(this.pin);
      // if(this.requestData.acRequest){
        try {
          const response = await this.$http.post('pin/check-auth', {
            pin: pin,
            acRequest: this.requestData.acRequest
          });
          if(response.data.error) {
            switch(response.data.error.id) {
              case 1:
                this.$anm22.eventBus.$emit("world-headbar-show-message", {
                  text: this.$anm22.strLang(
                    this.lang,
                    "User not found",
                    "Utente non trovato"
                  ),
                  type: "alarm"
                });
                break;
              case 2:
              case 3:
                this.$anm22.eventBus.$emit("world-headbar-show-message", {
                  text: this.$anm22.strLang(
                    this.lang,
                    "User not authorized",
                    "Utente non autorizzato"
                  ),
                  type: "alarm"
                });
                break;
              default:
                this.$anm22.eventBus.$emit("world-headbar-show-message", {
                  text: this.$anm22.strLang(
                    this.lang,
                    "Authorization error",
                    "Errore in fase di autorizzazione"
                  ),
                  type: "alarm"
                });
            }
            this.requestData.error(pin);
          } else {
            this.requestData.success(pin);
          }
        } catch(e) {
          const employment = this.$store.getters['foodEmployments/getByPin'](pin);
          if(employment) {
            const acs = this.$store.getters['foodAcs/get'](this.license.id + "-" + employment.permission);
            const auth = acs[this.requestData.acRequest];
            if(auth) {
              this.requestData.success(pin);
            } else {
              this.$anm22.eventBus.$emit("world-headbar-show-message", {
                text: this.$anm22.strLang(
                  this.lang,
                  "Employee not authorized",
                  "Dipendente non autorizzato"
                ),
                type: "alarm"
              });
              this.requestData.error(pin);
            }
          } else {
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "Employee not found",
                "Dipendente non trovato"
              ),
              type: "alarm"
            });
            this.requestData.error(pin);
          }
        } finally {
          this.endAuthRequest();
        }
      // } else {
      //   this.requestData.success(pin);
      //   this.endAuthRequest();
      // }
    }
  },
  mounted() {
    this.$anm22.eventBus.$on('food-pin-authorization', this.initAuthRequest);
  },
  beforeDestroy() {
    this.$anm22.eventBus.$off('food-pin-authorization', this.initAuthRequest);
  }
}
</script>

<style lang="scss" scoped>

</style>
